import AdGroupsDashboard from "./AdGroupsDashboard";

export default AdGroupsDashboard;
